import { createFileRoute } from "@tanstack/react-router";
import { ModuleDashboard } from "@/features/dashboards/ModuleDashboard";

// Quality dashboard (PX-QMS-010): features/dashboards.
export const Route = createFileRoute("/_app/quality/dashboard")({
  component: () => <ModuleDashboard module="quality" />,
});
